export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar contenedor"])},
          "go-back-link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a gestionar contenedor"])},
          "not_available_exportations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No se encontraron exportaciones para asignar"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])},
          "edit_comment_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar comentario visible por el cliente"])},
          "container_sealing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Precinto"])}
        }
      }
    }
  })
}